import { css } from 'styled-components';

export default css`
  .react-tel-input .form-control {
    width: 100% !important;
  }
`;
